import { undefDestroy } from '@webapp/common/lib/utils';

import type { Page } from '../common';

export const reverseMapPageParams = ({ name, onebyone, random, randomCount, randomFixed }: Partial<Page>): any =>
    undefDestroy({
        question_sp: typeof onebyone !== 'undefined' ? Number(onebyone) : undefined,
        title: typeof name !== 'undefined' ? name : undefined,
        question_count: randomCount,
        QUESTION_RANDOM_ORDERING: typeof random !== 'undefined' ? Number(random) : undefined,
        PAGE_RANDOM_ORDERING_FIXED: typeof randomFixed !== 'undefined' ? Number(randomFixed) : undefined,
    });
